/*
 * @Author: Nanxing Xiang
 * @Date: 2021-08-31 14:44:45
 * @LastEditors: Nanxing Xiang
 * @LastEditTime: 2021-08-31 14:53:05
 * @Description: file content
 */
import { useSearchParams } from '@easyvaas/react-hooks';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LocaleDetector = () => {
  const lang = useSearchParams('lang');
  const { i18n } = useTranslation();
  useEffect(() => {
    switch (lang) {
      case 'en': {
        i18n.changeLanguage('en');
        break;
      }
      case 'zh-Hant': {
        i18n.changeLanguage('tc');
        break;
      }
      default: {
        i18n.changeLanguage('sc');
        break;
      }
    }
  }, [i18n, lang]);
  return null;
};

export default React.memo(LocaleDetector);
